module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="">\n		<table class="m-list">\n			<thead class="m-list-header">\n				<tr>\n					';
 _.each(getListColumns(), function(column, key) { 
__p+='\n						<th class="'+
((__t=( getHideClasses(key) ))==null?'':__t)+
'">\n							';
 if (key === '_bulk' && hasBulk()) { 
__p+='<input type=\'checkbox\' class="js-bulk-select-all" ';
 if (areAllSelected()) { 
__p+='checked';
 } 
__p+=' />';
 } 
__p+='\n							';
 if (key === '_actions') { 
__p+='<div ><span >actions</span></div>';
 } 
__p+='\n							';
 if (column.sortable) { 
__p+='\n								<div class=\'list-sort js-sort-list\' data-field="'+
((__t=( key ))==null?'':__t)+
'" ><span >'+
((__t=( column.label ))==null?'':__t)+
'</span></div>\n							';
 } else { 
__p+='\n								<div ><span >'+
((__t=( column.label ))==null?'':__t)+
'</span></div>\n							';
 } 
__p+='\n						</th>\n\n					';
 }) 
__p+='\n<!-- 					<th><input type=\'checkbox\' class="js-bulk-select-all"  /></th>\n					<th ><div class=\'list-sort js-sort-list\' data-field="name" ><span >name</span></div></th>\n					<th ><div class=\'list-sort js-sort-list\' data-field="type" ><span >type</span></div></th>\n					<th ><div class=\'list-sort js-sort-list\' data-field="createdAt" ><span >created</span></div></th>\n					<th>actions</th> -->\n				</tr>\n			</thead>\n			<tbody class="bulk-tools-region"></tbody>\n			<tbody class="m-list-body list-body-region"></tbody>\n		</table>\n		<div class="pagination-region">\n		</div>\n	</div>\n\n\n\n\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/list-view/templates/list.html
// module id = 410
// module chunks = 0